<template><Toast />
	<div class="layout-topbar">
		<router-link to="/" class="layout-topbar-logo">
			<!-- <img alt="Logo" :src="topbarImage()" /> -->
			<img src="images/cmrfLogo.png" alt="Mahajyoti logo" style="width:40%;height: 20%;" >
			<!-- <span>CMRF</span> -->
			<h2>CM<span>RF</span></h2>

		</router-link>
		<button class="p-link layout-menu-button layout-topbar-button" @click="onMenuToggle">
			<i class="pi pi-bars"></i>
		</button>
		<b style="text-align: center;width: 75%;"><h1>Chief Minister  <span> Relief Fund</span></h1></b>

		<button class="p-link layout-topbar-menu-button layout-topbar-button"
			v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', 
			leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true}">
			<i class="pi pi-ellipsis-v"></i>
		</button>
		<ul class="layout-topbar-menu hidden lg:flex origin-top">
			<!-- <li>
				<button class="p-link layout-topbar-button">
					<i class="pi pi-calendar"></i>
					<span>Events</span>
				</button>
			</li>
			<li>
				<button class="p-link layout-topbar-button">
					<i class="pi pi-cog"></i>
					<span>Settings</span>
				</button>
			</li> -->
			
			<li>
				<button class="p-link layout-topbar-button" @click="toggleMenu">
					<img v-if="isValidPhotoUrl(profilephoto)" :src=profilephoto :alt=profilephoto style="height: 100%;width: 100%;border-radius: 50%;">	
					<i v-else class="pi pi-user"></i> <br>
					<span>Profile</span>
					<Menu ref="menu" :model="overlayMenuItems" :popup="true" />
					
				</button>
				<br><p>{{showname}}</p>
				
			</li>
		</ul>
	</div>

	<Dialog
          v-model:visible="profileDialog"
		  :breakpoints="{'960px': '75vw'}"
          :style="{ width: '60vw' }"
          header="Profile Details"
          :modal="true"
		  position="top"
        >
		<div class="col-12">
			<div class="p-fluid formgrid grid" style="margin-top: 2%;">
				<div class="field col-12 md:col-6" style="margin-top: 1%;">
                        <span class="p-float-label">
                            <InputText id="name" type="text" v-model="name"
							v-tooltip.bottom="'Full Name'"/>
                            <label for="name">Name</label>
                        </span>
                </div>
				<div class="field col-12 md:col-6" style="margin-top: 1%;">
                        <span class="p-float-label">
                            <InputText id="email" type="text" v-model="email"
							v-tooltip.bottom="'Email'"/>
                            <label for="email">Email</label>
                        </span>
                </div>
				<div class="field col-12 md:col-6" style="margin-top: 1%;">
                        <span class="p-float-label">
                            <InputText id="mobile_no" type="number" v-model="mobile"
                            v-tooltip.bottom="'Mobile number'" />
                            <label for="mobile_no">Mobile</label>
                        </span>
                </div>
				<div class="field col-12 md:col-6" style="margin-top: 1%;">
                        <span class="p-float-label">
                            <InputText id="state" type="text" v-model="state"
                            v-tooltip.bottom="'State'" />
                            <label for="state">State</label>
                        </span>
                </div>
				<div class="field col-12 md:col-6" style="margin-top: 1%;">
                        <span class="p-float-label">
                            <Textarea id="address" type="text" v-model="address"
                            v-tooltip.bottom="'Address'" />
                            <label for="address">Address</label>
                        </span>
                </div>
				<div class="field col-12 md:col-6" style="margin-top: 1%;">
                        <span class="p-float-label">
                            <InputText id="city_village" type="text" v-model="city_village"
                            v-tooltip.bottom="'City or Vilage'" />
                            <label for="city_village">City Or Village</label>
                        </span>
                </div>
				<div class="field col-12 md:col-6" style="margin-top: 1%;">
                        <span class="p-float-label">
                            <InputText id="taluka" type="text" v-model="taluka"
                            v-tooltip.bottom="'Taluka'" />
                            <label for="taluka">Taluka</label>
                        </span>
                </div>
				<div class="field col-12 md:col-6" style="margin-top: 1%;">
                        <span class="p-float-label">
                            <InputText id="district" type="text" v-model="district"
                            v-tooltip.bottom="'District'" />
                            <label for="district">District</label>
                        </span>
                </div>
				<div class="field col-12 md:col-6" style="margin-top: 1%;">
                        <span class="p-float-label">
                            <InputText id="pincode" type="number" v-model="pincode"
                            v-tooltip.bottom="'Pincode'" />
                            <label for="pincode">Pincode</label>
                        </span>
                </div>
				
				<div class="field col-12 md:col-3" style="margin-top: 1%;">
					<FileUpload
						class="p-button-primary"
						mode="basic"
						name="profile_photo"
						:auto="true"
						:custom-upload="true"
						chooseLabel="Profile Photo"
						@uploader="handleFileUpload"
					/>

                </div>
				<div class="field col-12 md:col-3" style="margin-top: 1%;">
					<img :src="profile_photo" :alt="profile_photo" v-if="profile_photo"
                                        class="shadow-2" width="70">
                    <img v-else src="https://media.istockphoto.com/vectors/no-image-available-icon-vector-id1216251206?k=6&m=1216251206&s=612x612&w=0&h=G8kmMKxZlh7WyeYtlIHJDxP5XRGm9ZXyLprtVJKxd-o="
                                        class="shadow-2" width="70" />
                </div>
					
			</div>
		</div>
		<template #footer>
		<Button label="Save" @click="updateUser" icon="pi pi-check" class="p-button-success"/>
		</template>
		</Dialog>

	<Dialog
          v-model:visible="productDialog"
          :style="{ width: '450px', width: '450px' }"
          header="Change Password"
          :modal="true"
          class="p-fluid"
        >

		 				<label for="password1" class="block text-900 font-medium text-xl mb-2">Old Password</label>
                        <Password id="password1" v-model="old_password" placeholder="Password" :toggleMask="true" class="w-full mb-3" inputClass="w-full" inputStyle="padding:1rem"></Password>
						 <label for="password1" class="block text-900 font-medium text-xl mb-2">New Password</label>
                        <Password id="password1" v-model="new_password" placeholder="Password" :toggleMask="true" class="w-full mb-3" inputClass="w-full" inputStyle="padding:1rem"></Password>
						 <label for="password1" class="block text-900 font-medium text-xl mb-2">Confirm Password</label>
                        <Password id="password1" v-model="conf_password" placeholder="Password" :toggleMask="true" class="w-full mb-3" inputClass="w-full" inputStyle="padding:1rem"></Password>
						<Button label="Change Password" class="p-button-rounded p-button-success" @click="change()" />
		</Dialog>
</template>

<script>
import apis from "@/apis";
import axios from "axios";
export default {
	data() {
		
			return {
				profilephoto:'',
				showname:'',
				conf_password: "",
				new_password: "",
				old_password: "",
				productDialog:false,
				profileDialog:false,
				name:"",
				email:"",
				mobile:"",
				state:"",
				address:"",
				city_village:"",
				taluka:"",
				district:"",
				pincode:"",
				profile_photo:"",
				userDetails:"",
				overlayMenuItems: [
					 {
					 	label: 'My Profile',
						icon: 'pi pi-user',
					 	command:() =>{
							this.profileDialog = true;
						}
					 },
					// {
					// 	label: 'Change Password',
					// 	icon: 'pi pi-pencil',
					// 	command: () => {
					// 		this.conf_password= "";
					// 		this.new_password= "";
					// 		this.old_password= "";
					// 		this.productDialog = true;
							
          			// 	}
					// },
					{
						label: 'Logout',
						icon: 'pi pi-sign-in',
						to:'/',
						// click: () => {
							command: () => {
						//	this.$session.destroy();
      				localStorage.clear();
      				this.$router.push("/");
            	return false;
          }
					},
					
				],
			}
	},
	watch: {
    profileDialog(newValue) {
      if (newValue) {
        this.getUserData();
      }
    },
  },
    methods: {
		 isValidPhotoUrl(url) {
    if (!url) return false;
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
    try {
        const parsedUrl = new URL(url);
        return imageExtensions.includes(parsedUrl.pathname.split('.').pop().toLowerCase());
    } catch {
        return false;
    }
},
		change()
		{
			
			 if (!this.old_password) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Old password",
          life: 3000,
        });
        return false;
      }
	   if (!this.new_password) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter New password",
          life: 3000,
        });
        return false;
      }
	   if (!this.conf_password) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Confirm password",
          life: 3000,
        });
        return false;
      }
	  if (this.conf_password != this.new_password) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Confirm Password Not Match With Password",
          life: 3000,
        });
        return false;
      }
	  var uname="";
	  if (localStorage.getItem("user_key")=='student') 
	  {
		uname=localStorage.getItem('mobile');
	  }
	  else
	  {
		uname=localStorage.getItem('email');
	  }

		//api
      	var data = {
        username: uname,
        password: this.new_password,
        type: localStorage.getItem('user_key'),
      };
    
      var promise = apis.passwordreset(data, this.id);
      promise.then((response) => {
     
			this.productDialog = false;
        	this.$swal(response.data.message);
        	this.update_pass_Dialog = false;
		 	localStorage.clear();
      		this.$router.push("/"); 
      }).catch((error) => {
            //console.log(error);
          	this.productDialog = false;
			this.$swal.fire(error.response.data);
         
          });

			


		
			
		},
			toggleMenu(event) {
				this.$refs.menu.toggle(event);
			},
        onMenuToggle(event) {
            this.$emit('menu-toggle', event);
        },
		onTopbarMenuToggle(event) {
            this.$emit('topbar-menu-toggle', event);
        },
		topbarImage() {
			return this.$appState.darkTheme ? 'images/logo.png' : 'images/logo.png';
		},
		async getUserData() {
      let details = {
        
        "uid": localStorage.getItem('id'),
		"Limit": 1,
    "page_no": 1,
    "count": false,
      }
      var promise = apis.PwdUserList(details);
      promise.then((response) => {
        //this.$swal(response.data.message);
		this.userDetails = response.data.data[0];
		this.name = response.data.data[0].name;
		this.email = response.data.data[0].email;
		this.mobile = response.data.data[0].mobile;
		this.state = response.data.data[0].state;
		this.address= response.data.data[0].address;
		this.city_village = response.data.data[0].citY_VILLAGE;
		this.taluka = response.data.data[0].taluka;
		this.district = response.data.data[0].district;
		this.taluka = response.data.data[0].taluka;
		this.pincode = response.data.data[0].pincode;
		this.profile_photo = response.data.data[0].profilE_PHOTO;
		//console.log("userdata",this.userDetails);
		
      });
    },
		
		async handleFileUpload(event) {
				if (!event.files || event.files.length === 0) {
					console.error("No file selected");
					return;
				}

				var fileUp = event.files[0];  // Correctly access the file
				var filetype = fileUp.type;
				if (!filetype.startsWith('image/')) {
						this.$toast.add({
							severity: "error",
							summary: "Error",
							detail: "Please select only an image file.",
							life: 3000,
						});
						return false;
					}
				var filepath = 'CMRF/' + fileUp.name;
				var file = fileUp;

				var data = {
					filePath: filepath,
					contentType: filetype
				};

				try {
					// Upload to AWS
					let response = await apis.upload_to_AWS(data);
					let signedUrl = response.data.url;

					var uploadOptions = {
						headers: {
							'Access-Control-Allow-Origin': '*',
							'Content-Type': filetype
						}
					};

					await axios.put(signedUrl, file, uploadOptions);

					// Set the profile photo URL
					this.profile_photo = `https://edukatta-docs.s3.ap-south-1.amazonaws.com/${filepath}`;
					
					
				} catch (error) {
					console.error('File upload failed:', error);
				}
			},

		async updateUser()
		{
			this.submitted = true;
			if(!this.name)
			{
			this.$toast.add({
					severity: "error",
					summary: "error",
					detail: "Please Enter name",
					life: 3000,
				});
				return false;
			}
			
			if (!this.email) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter email",
                    life: 3000,
                });
                return false;
            }
            var emailreg = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
            if (this.email) {
                if (emailreg.test(this.email) == false) {
                    this.$toast.add({
                        severity: "error",
                        summary: "error",
                        detail: "Please enter valid email",
                        life: 3000,
                    });
                    return false;
                }
            }
			const phoneRegex = /^[0-9]{10}$/;
            if (!this.mobile || (this.mobile && !phoneRegex.test(this.mobile))) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter mobile",
                    life: 3000,
                });
                return false;
            }
			if(!this.state)
			{
			this.$toast.add({
					severity: "error",
					summary: "error",
					detail: "Please Enter State",
					life: 3000,
				});
				return false;
			}
			if(!this.address)
			{
			this.$toast.add({
					severity: "error",
					summary: "error",
					detail: "Please Enter address",
					life: 3000,
				});
				return false;
			}
			if(!this.city_village)
			{
			this.$toast.add({
					severity: "error",
					summary: "error",
					detail: "Please Enter city or village",
					life: 3000,
				});
				return false;
			}
			let details={
				"uid": localStorage.getItem('id'),
				"name" : this.name,
				"email": this.email,
				"mobile" :this.mobile,
				"state" : this.state,
				"address" : this.address,
				"citY_VILLAGE" : this.city_village,
				"taluka" : this.taluka,
				"district" :this.district,
				"pincode" :this.pincode,
				"profilE_PHOTO" : this.profile_photo,
				"password" : this.userDetails.password,
				"status" : this.userDetails.status,
				"clientid": this.userDetails.clientid,
				"user_role_id" : this.userDetails.user_role_id,
				"user_role_name" : this.userDetails.user_role_name,
				}
				console.log("data",details);

				var promise = apis.InsertUpdatePwd(details);
					promise.then((responseapi) => {
           
				this.$swal.fire({
					icon: "success",
					title: "Success",
					width: 350,
					text: responseapi.data.message,
				});
				
				this.profileDialog = false;
				
				})
				.catch((error) => {
				//console.log(error);
				
				this.profileDialog = false;

				// this.$swal.fire(error.response.data);
				this.$swal.fire({
					icon: "error",
					title: "Error",
					width: 350,
					text: error.response?.data?.message,
				});
					
				});
		},
    },
		mounted(){
			//this.getUserData();
			this.showname= localStorage.getItem("email");
			this.profilephoto= localStorage.getItem("profile_photo");
	// 		if (localStorage.getItem('userData')) {
    //     this.data = JSON.parse(localStorage.getItem('userData'));
        
    //     // Assign properties
    //     this.name = this.data.name;
    //     this.email = this.data.email;
    //     this.mobile = this.data.mobile;
    //     this.state = this.data.state;
    //     this.address = this.data.address;
    //     this.city_village = this.data.citY_VILLAGE; 
    //     this.taluka = this.data.taluka;
    //     this.district = this.data.district;
    //     this.pincode = this.data.pincode;
    //     this.profile_photo = this.data.profilE_PHOTO;
    // }

		},
	computed: {
		darkTheme() {
			return this.$appState.darkTheme;
		}
	}
}
</script>
<style scoped>
.layout-topbar .layout-topbar-logo {
   
    width: 150px;
   
}
h1 {
    color: #efa40a;
    display: inline-block;
    font-family: "oswald_bold";
    font-size: 30px;
    font-weight: bolder;
    padding: 5px 0 0 0px;
    text-transform: uppercase;
}
h1 span {
    color: #09517a;
}


h2 {
    color: #efa40a;
    display: inline-block;    
    font-size: 20px;
    font-weight: bolder; 
    text-transform: uppercase;
}
h2 span {
    color: #09517a;
}




</style>